import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js'
import { CloseViewEvent } from 'src/events/close-view';
import { IconButton } from '@material/mwc-icon-button';

IconButton;

@customElement('close-button')
export class CloseButton extends LitElement {
  static styles = [
    css`
      :host {
        display: block;
      }
    `
  ];

  clickHandler = (e: Event) => {
    this.dispatchEvent(new CloseViewEvent())
  }
  connectedCallback(): void {
    super.connectedCallback();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
  }
  render() {
    return html`
    <slot @click=${this.clickHandler}>
      <mwc-icon-button icon="close"></mwc-icon-button>
    </slot>
     
    `;
  }
}
